import Image from "next/image"

import { cn } from "@/lib/utils"

/** Circular maroon-shadowed crest used on splash / auth screens. */
export function LogoBadge({
  size = 128,
  className,
}: {
  size?: number
  className?: string
}) {
  return (
    <div
      className={cn(
        "psc-logo-vt relative shrink-0 overflow-hidden rounded-full shadow-[0_10px_30px_rgba(123,35,53,0.1)]",
        className
      )}
      style={{ width: size, height: size }}
    >
      <Image
        src="/logo.png"
        alt="Pakubuwono Social Club"
        fill
        priority
        sizes="128px"
        className="object-cover"
      />
    </div>
  )
}
